<template>
    <div v-if="service.pricingSourceType === 'PRIVATE'" class="text-info">
        {{ $t(`pricingSourceType.${service.pricingSourceType}`) }}
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class PricingSourceTypeLabel extends Vue {
        @Prop({required: true, type: Object}) service
    }

    export default PricingSourceTypeLabel
</script>
